'use client';

import { createContext, useCallback, useMemo, useState } from "react";

const ToastContext = createContext({
    toasts: [],
    addToast: function(toastData) {}
});

export function ToastContextProvider(props) {
    const [activeToasts, setActiveToasts] = useState([]);

    const removeToastToasthandler = useCallback((id) => {
        if(id !== undefined) setActiveToasts(prev => prev.filter(p => p.id !== id))
    }, []);

    const addToasthandler = useCallback((toastData) => {
        setActiveToasts(prev => {
            const new_id = prev.length === 0 ? 0 : prev[0].id+1;
            return ([
                {id: new_id, ...toastData, x_click: () => removeToastToasthandler(new_id)},
                ...prev
            ]);
        })
    }, [removeToastToasthandler]);

    const context = useMemo(() => ({
        toasts: activeToasts,
        addToast: addToasthandler
    }), [activeToasts, addToasthandler]);

    return <ToastContext.Provider value={context}>
        {props.children}
    </ToastContext.Provider>
}

export default ToastContext;